<template>
  <v-tabs color="primary">
    <v-tab>General</v-tab>
    <v-tab @change="getNotes">Notes</v-tab>
    <v-tab-item :key="`payment-${item.data.id}-general`">
      <v-progress-linear indeterminate v-if="dataLoading"></v-progress-linear>
      <v-container fluid>
        <v-row align="center">
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field label="Payment ID" readonly hide-details :value="item.data.id"></v-text-field>
            <v-text-field label="Payment Method" readonly hide-details :value="item.data.paymentType"></v-text-field>
            <v-text-field label="Payment Status" readonly hide-details :value="item.data.status"></v-text-field>
            <v-text-field label="Amount" readonly hide-details :value="`${item.data.currencySymbol}${item.data.amount}`"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field label="Affiliate ID" readonly hide-details :value="item.data.affiliate_id"></v-text-field>
            <v-text-field label="Affiliate Name" readonly hide-details :value="item.data.affiliateName"></v-text-field>
            <v-text-field label="Affiliate Email" readonly hide-details :value="item.data.affiliate.email"></v-text-field>
            <v-text-field label="Affiliate Manager" readonly hide-details :value="item.data.affiliate_manager_name"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="12">
            <v-form @submit.prevent="submitHandler">
              <h4>Action</h4>
              <div class="d-flex align-center mt-2 mb-4">
                <div>Note</div>
                <v-switch
                    class="ml-4 mr-0 mt-0 pt-0"
                    v-model="isModification"
                    :disabled="!['pending', 'active', 'approved'].includes(item.data.status)"
                    hide-details
                    inset
                ></v-switch>
                <div>Modification</div>
              </div>
              <v-text-field v-if="isModification"
                            type="number" step="0.01"
                            label="Amount"
                            hint="Can contain positive values (for credits) or negative values (for penalties)"
                            v-model="modificationAmount"></v-text-field>
              <v-textarea label="Note"
                          outlined
                          rows="3"
                          :placeholder="isModification ? 'Modification reason' : 'Add your note here'"
                          v-model="note"></v-textarea>
              <v-btn type="submit" :loading="formLoading" color="primary">Save</v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`payment-${item.data.id}-notes`">
      <v-progress-linear v-show="notesTab.loading"
                         indeterminate
      ></v-progress-linear>
      <v-container fluid class="pa-0">
        <v-data-table
            :headers="notesTab.headers"
            :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
            :items="notesTab.items"
            :footer-props="{itemsPerPageOptions: notesTab.pageOptions}"
            :page="1"
            :items-per-page="25"
            loading-text="Loading... Please wait"
            fixed-header
            :class="`elevation-0 mb-0 co-data-table items-size-45`"
            item-class="td_title"
        >
          <template v-slot:item.date_added="{ item }" >
            {{getPrettyDate(item.date_added)}}
          </template>
          <template v-slot:item.action="{ item }" >
            {{ item.payment_modification ? 'Modification' : 'Note' }}
          </template>
          <template v-slot:item.note="{ item }" >
            <short-text :text="item.note"></short-text>
          </template>
          <template v-slot:item.amount="{ item }" >
            {{ item.payment_modification && item.payment_modification.amount
              ? `${item.payment_modification.item_currency}${item.payment_modification.amount}`
              : 'N/A' }}
          </template>
        </v-data-table>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import store from "@/store";
import paymentsApi from '@/api/payments';
const { DateTime } = require("luxon");

export default {
  props: {
    item: {
      type: Object
    }
  },
  async mounted() {
  },
  methods: {
    async submitHandler() {
      // validate
      // send request to add modification or note
      try {
        this.formLoading = true;
        if (this.isModification) {
          const result = await paymentsApi.addPaymentModification({
            paymentId: this.item.data.id,
            note: this.note,
            amount: this.modificationAmount
          });
          if (!result) {
            store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
          }
        } else {
          const result = await paymentsApi.addNote({paymentId: this.item.data.id, note: this.note});
          if (!result) {
            store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
          }
        }
        store.dispatch('alert/ALERT_SUCCESS', `${this.isModification ? 'Modification' : 'Note'} has been added`, {root: true});
        this.isModification = false;
        this.note = '';
        this.modificationAmount = 0;
        setTimeout(() => {store.dispatch('alert/ALERT_REMOVE')}, 3000);
      } catch (error) {
        console.error(error);
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      } finally {
        this.formLoading = false;
      }
    },
    async getNotes() {
      try {
        this.notesTab.loading = true;
        const result = await paymentsApi.getNotes({
          paymentId: this.item.data.id,
        });
        if (!result) {
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
        } else {
          this.notesTab.items = result;
        }
      } catch (err) {

      } finally {
        this.notesTab.loading = false;
      }
    },
    getPrettyDate(date) {
      const modifiedDate = DateTime.fromISO(date, {zone: 'UTC'}).toFormat('DDD T');
      if (!modifiedDate) {
        return date;
      }
      return modifiedDate;
    }
  },
  computed: {
  },
  name: 'PaymentCard',
  data() {
    return {
      dataLoading: false,
      isModification: false,
      modificationAmount: 0.00,
      note: '',
      formLoading: false,
      notesTab: {
        loading: false,
        headers: [
          {text: 'Date Added', value: 'date_added', align: 'center'},
          {text: 'Note', value: 'note', class: 'color', align: 'center'},
          {text: 'Author', value: 'author_email', class: 'color', align: 'center'},
          {text: 'Action', value: 'action', class: 'color', align: 'center'},
          {text: 'Amount', value: 'amount', align: 'center'},
        ],
        items: [],
        pageOptions: [10, 25, 50, 100],
      }
    }
  }
}
</script>

<style scoped>

</style>
